import { jsxs as L, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as e } from "./index.es2447.js";
function i({ size: C = e }) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M17.6324 17.7932C17.6324 17.2409 18.0801 16.7932 18.6324 16.7932H24.6852V22.8399C24.6852 24.4967 23.3421 25.8399 21.6852 25.8399H20.6324C18.9755 25.8399 17.6324 24.4967 17.6324 22.8399V17.7932Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.7009 33.1951V29.9187C25.7009 28.4423 24.504 27.244 23.0263 27.244H19.1761C17.6997 27.244 16.5015 28.4423 16.5015 29.9187V33.1951L20.3396 39.5701H21.8788L25.7009 33.1951Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M20.4022 22.7641C20.3032 22.5054 20.0133 22.3759 19.7546 22.4748C19.4959 22.5738 19.3664 22.8637 19.4653 23.1224C19.7167 23.7797 20.3504 24.2525 21.1012 24.2525C21.8537 24.2525 22.4858 23.7794 22.7371 23.1224C22.8361 22.8637 22.7065 22.5738 22.4478 22.4748C22.1891 22.3759 21.8992 22.5054 21.8003 22.7641C21.6905 23.0512 21.4186 23.2495 21.1012 23.2495C20.7848 23.2495 20.5118 23.0509 20.4022 22.7641Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9413 18.2895C16.9413 17.0253 17.9672 16 19.2322 16H25.2608L25.2612 22.355C25.2612 24.5832 23.4398 26.4044 21.2105 26.4044H20.9912C18.763 26.4044 16.9417 24.5831 16.9417 22.355L16.9413 18.2895ZM17.9447 19.6776H24.2582V22.355C24.2582 24.029 22.8861 25.4014 21.2105 25.4014H20.9912C19.317 25.4014 17.9447 24.0292 17.9447 22.355V19.6776ZM24.2578 17.003V18.6746H17.9443V18.2895C17.9443 17.5798 18.5206 17.003 19.2322 17.003H24.2578Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 29.9188C16 28.1654 17.4228 26.7427 19.1761 26.7427H23.0263C24.7812 26.7427 26.2024 28.1656 26.2024 29.9188V33.1953C26.2024 33.2861 26.1778 33.3752 26.1311 33.4531L22.309 39.8282C22.2184 39.9793 22.0551 40.0718 21.8789 40.0718H20.3396C20.1637 40.0718 20.0007 39.9796 19.91 39.829L16.0719 33.4539C16.0248 33.3758 16 33.2864 16 33.1953V29.9188ZM19.1761 27.7457C17.9767 27.7457 17.003 28.7194 17.003 29.9188V33.0559L18.2569 35.1386V31.1389C18.2569 30.862 18.4814 30.6374 18.7584 30.6374C19.0353 30.6374 19.2599 30.862 19.2599 31.1389V36.7704C19.2599 36.7813 19.2595 36.7921 19.2588 36.8028L20.6231 39.0688H21.5948L22.946 36.8151C22.9447 36.8004 22.9441 36.7855 22.9441 36.7704V31.1389C22.9441 30.862 23.1686 30.6374 23.4456 30.6374C23.7225 30.6374 23.9471 30.862 23.9471 31.1389V35.1454L25.1995 33.0564V29.9188C25.1995 28.7192 24.2269 27.7457 23.0263 27.7457H19.1761Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M40 22.7612L35.8622 18.6234L35.1529 19.3326L38.0802 22.2599L29.352 22.2603L29.352 23.2633L38.0804 23.2628L35.1529 26.1914L35.8622 26.9005L40 22.7612Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M34.1593 30.8248L33.4499 30.1157L29.3122 34.255L33.45 38.3928L34.1592 37.6836L31.232 34.7563L39.9602 34.7559L39.9601 33.7529L31.2318 33.7534L34.1593 30.8248Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricVisitsIcon
};
//# sourceMappingURL=index.es430.js.map
